import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";
import { format } from "date-fns";

import { FaDownload } from "react-icons/fa";

import { Flex, Button, Icon, Link, SimpleGrid, Box } from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import Group from "../Visualizar/Group";
import Table from "./Table";

import RegularidadeSAService from "../../../../main/services/RegularidadeSAService";
import { API } from "../../../../main/config";

import { useAppContext } from "../../../../Context/MessageContextProvider";

import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";

const RegularidadeServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const { idPJ } = useAppContext();

  const styleSpan = {
    wordBreak: "break-word",
  };

  const columnsNrRegistroCMDCA = [
    {
      Header: "Número de Registro",
      accessor: "numeroRegistro",
      Cell: (props) => {
        return (
          <span style={styleSpan} title={props.value}>
            {props.value && props.value.length > 50
              ? props.value.substring(0, 50) + "..."
              : props.value
              ? props.value
              : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Validade",
      accessor: "validadeNrRegistro",
      Cell: (props) => {
        return (
          <span style={styleSpan}>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataAnexoNrRegistro",
      Cell: (props) => {
        return (
          <span style={styleSpan}>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Arquivo",
      accessor: "anexoNrRegistro",
      Cell: (props) => {
        return (
          <span>
            {props?.value && props?.value?.pathAnexo ? (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            ) : (
              "Não possui"
            )}
          </span>
        );
      },
    },
  ];

  const columnsNrInscricaoCMDCA = [
    {
      Header: "Número de Inscrição",
      accessor: "numeroInscricao",
      Cell: (props) => {
        return (
          <span style={styleSpan} title={props?.value}>
            {props.value && props.value.length > 50
              ? props.value.substring(0, 50) + "..."
              : props.value && props.value.length <= 50
              ? props.value
              : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Validade",
      accessor: "validadeNrInscricao",
      Cell: (props) => {
        return (
          <span style={styleSpan}>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataAnexoNrInscricao",
      Cell: (props) => {
        return (
          <span style={styleSpan}>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Arquivo",
      accessor: "anexoNrInscricao",
      Cell: (props) => {
        return (
          <span>
            {props?.value && props?.value?.pathAnexo ? (
              <Link
                href={
                  props?.value?.pathAnexo.toString().includes(".png") ||
                  props?.value?.pathAnexo.toString().includes(".jpg") ||
                  props?.value?.pathAnexo.toString().includes(".jpeg") ||
                  props?.value?.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props?.value?.id}/visualizar`
                    : API + `/anexos/${props?.value?.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            ) : (
              "Não possui"
            )}
          </span>
        );
      },
    },
  ];

  const columnsNrInscricaoCMAS = [
    {
      Header: "Número de Inscrição",
      accessor: "numeroInscricaoCMAS",
      Cell: (props) => {
        return (
          <span style={styleSpan} title={props?.value}>
            {props.value && props.value.length > 50
              ? props.value.substring(0, 50) + "..."
              : props.value && props.value.length <= 50
              ? props.value
              : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Validade",
      accessor: "validadeNrInscricaoCMAS",
      Cell: (props) => {
        return (
          <span style={styleSpan}>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataAnexoNrInscricaoCMAS",
      Cell: (props) => {
        return (
          <span style={styleSpan}>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Arquivo",
      accessor: "anexoNrInscricaoCMAS",
      Cell: (props) => {
        return (
          <span>
            {props.value ? (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            ) : (
              "Não possui"
            )}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    RegularidadeSAService.getRegularidadeSA(id)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data) {
            if (erro.response.data.status === 404) {
              history.push(`/servico-acolhimento/cadastrar-regularidade/${id}`);
            }
          }
        }
      });
  }, [history, id]);

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.regularidadeVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loading && data ? (
      <>
        <Group title="CMDCA" regularidade={true}>
          {data.servicoAcolhimento.naturezaServico === "privada" && (
            <Table data={[data]} columns={columnsNrRegistroCMDCA} />
          )}
          <Table data={[data]} columns={columnsNrInscricaoCMDCA} />
        </Group>
        {data.servicoAcolhimento.naturezaServico === "privada" && (
          <Group title="CMAS" regularidade={true}>
            <Table data={[data]} columns={columnsNrInscricaoCMAS} />
          </Group>
        )}

        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={servicos.regularidadeEditar}
            id={idPJ}
            user={user}
          >
            <Button
              id="button-editar"
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              fontSize="15px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              onClick={() => {
                history.push("/servico-acolhimento/editar-regularidade/" + id);
              }}
            >
              Editar
            </Button>
          </Permission>
        </SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default RegularidadeServicoAcolhimento;
